import { render, staticRenderFns } from "./SecondGuessYourselfQuestion.vue?vue&type=template&id=649ac846&scoped=true&"
import script from "./SecondGuessYourselfQuestion.vue?vue&type=script&lang=ts&"
export * from "./SecondGuessYourselfQuestion.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "649ac846",
  null
  
)

export default component.exports